import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const raman = {
    jpath: ['spectra', 'raman'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default raman;
//# sourceMappingURL=raman.js.map